var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiguretrackandfield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.5811 29.4023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 29.4023,
    opacity: 0,
    width: 23.5811,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7769 5.12109C15.1831 5.12109 16.3316 3.98438 16.3316 2.54297C16.3316 1.13672 15.1831 0 13.7769 0C12.3589 0 11.2105 1.13672 11.2105 2.54297C11.2105 3.98438 12.3589 5.12109 13.7769 5.12109ZM2.37453 19.2305L10.0972 19.2305C11.1753 19.2305 11.6441 18.0352 11.0347 17.2969L8.62062 14.332L15.5347 13.875L22.0269 13.875C22.6831 13.875 23.2339 13.3477 23.2339 12.6914C23.2339 12.0469 22.6831 11.4961 22.0269 11.4961L10.0152 11.4961L12.8511 8.64844C12.98 8.53125 13.1441 8.44922 13.3198 8.47266L21.8277 9.57422C22.5191 9.65625 23.1519 9.12891 23.1519 8.40234C23.1519 7.81641 22.7183 7.30078 22.1206 7.23047L4.30812 4.98047C3.93312 4.93359 3.59328 5.0625 3.32374 5.30859L0.347182 8.28516C-0.121568 8.75391-0.109849 9.46875 0.347182 9.94922C0.769057 10.3945 1.54249 10.4414 2.02296 9.94922L4.58937 7.39453L7.36671 7.74609C7.62453 7.76953 7.72999 8.05078 7.54249 8.23828L4.91749 10.8281C3.89796 11.8359 3.83937 13.4648 4.91749 14.543L7.21437 16.8633L2.37453 16.8633C1.71828 16.8633 1.19093 17.3906 1.19093 18.0469C1.19093 18.6914 1.71828 19.2305 2.37453 19.2305ZM13.9058 29.4023C14.2691 29.4023 14.5503 29.1211 14.5503 28.7578L14.5503 16.5469C14.5503 16.1836 14.2691 15.9023 13.9058 15.9023C13.5425 15.9023 13.2495 16.1836 13.2495 16.5469L13.2495 28.7578C13.2495 29.1211 13.5425 29.4023 13.9058 29.4023Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiguretrackandfield);
export default __webpack_public_path__ + "static/media/figure.track.and.field.e88d3915989221f6409c4e6f32db5c20.svg";
export { ForwardRef as ReactComponent };